import $api from '../services';

export default {
    list(params) {
        return $api.get('/users', params);
    },
    listByBusiness(params) {
        return $api.get('/users', params.params);
    },
    resetPassword(id) {
        return $api.post(`/users/${id}/reset-password`);
    },
    updateStatus(id, params) {
        return $api.put(`/users/${id}/status`, params);
    },
    changeToBtc(id) {
        return $api.put(`/users/${id}/btc`);
    },
    delete(id) {
        return $api.delete(`/users/${id}`);
    },
    deleteAsAdmin(params) {
        return $api.delete(`/users/members/${params.id}`);
    },
    deleteAsChampion(params) {
        return $api.delete(
            `/profile/business/${params.businessId}/members/${params.id}`
        );
    },
    create(params) {
        return $api.post('/users', params);
    },
    update(id, params) {
        return $api.put(`/users/${id}`, params);
    },
    read(id, params) {
        return $api.get(`/users/${id}`, params);
    },
    setRating(id, params) {
        return $api.put(`/users/${id}/rating`, params);
    },
    sendPush(id, params) {
        return $api.post(`/users/${id}/send-push`, params);
    },
    setPassword(id, params) {
        return $api.post(`/users/${id}/set-password`, params);
    }
};
